import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import styled from "@emotion/styled";
import { layers } from "../../../constants/layers";
import { WIDTH_ENUM, gutter } from "../shared-variables";
import { getBackgroundColor, getBorderRadius, getBoxShadow, getColor } from "./modalTheme";
var maxWidthDimensions = "calc(100% - ".concat(gutter * 2, "px)");
var maxHeightDimensions = function maxHeightDimensions(gutterHeight) {
  if (typeof gutterHeight === "string") {
    var percent = parseInt(gutterHeight);
    return "".concat(100 - percent * 2, "%");
  }
  var gutterHeightPx = typeof gutterHeight === "number" ? gutterHeight : gutter;
  return "calc(100% - ".concat(gutterHeightPx * 2, "px)");
};
export var modalWidth = function modalWidth(_ref) {
  var widthName = _ref.widthName,
    widthValue = _ref.widthValue;
  if (typeof widthValue === "number") {
    return "".concat(widthValue, "px");
  }
  return widthName ? "".concat(WIDTH_ENUM.widths[widthName], "px") : widthValue || "auto";
};
export var modalHeight = function modalHeight(_ref2) {
  var heightValue = _ref2.heightValue;
  if (typeof heightValue === "number") {
    return "".concat(heightValue, "px");
  }
  return heightValue || "auto";
};
var positionerAbsoluteTop = function positionerAbsoluteTop(gutterHeight) {
  if (typeof gutterHeight === "string") {
    return gutterHeight;
  }
  var gutterHeightPx = typeof gutterHeight === "number" ? gutterHeight : gutter;
  return "".concat(gutterHeightPx, "px");
};
export var FillScreen = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 100vh;\n    left: 0;\n    overflow-y: auto;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: ", ";\n    -webkit-overflow-scrolling: touch;\n"])), layers.modal);
FillScreen.displayName = "StyledFillScreen";
export var PositionerAbsolute = styled("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: ", ";\n    left: 0;\n    right: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: ", ";\n    height: ", ";\n    max-width: ", ";\n    margin-left: auto;\n    margin-right: auto;\n    z-index: ", ";\n    pointer-events: none;\n\n    @media (min-width: 320px) and (max-width: 480px) {\n        position: fixed;\n        left: 0;\n        top: 0;\n        height: 100%;\n        width: 100%;\n        max-width: 100%;\n    }\n"])), function (_ref3) {
  var gutterHeight = _ref3.gutterHeight;
  return positionerAbsoluteTop(gutterHeight);
}, function (_ref4) {
  var placement = _ref4.placement;
  return placement === "center" ? "center" : "flex-start";
}, function (_ref5) {
  var gutterHeight = _ref5.gutterHeight;
  return maxHeightDimensions(gutterHeight);
}, maxWidthDimensions, layers.modal);
PositionerAbsolute.displayName = "StyledPositionerAbsolute";
export var StyledModalContainer = styled("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    color: ", ";\n    display: flex;\n    flex-direction: column;\n    height: ", ";\n    max-height: 100%;\n\n    /* the parent (PositionerAbsolute) turns off pointer events, so we need to turn it back on */\n    pointer-events: auto;\n\n    @media (min-width: 320px) and (max-width: 480px) {\n        height: 100%;\n        max-height: 100%;\n        border-radius: 0;\n    }\n"])), getBackgroundColor, getBorderRadius, getBoxShadow, getColor, function (_ref6) {
  var heightValue = _ref6.heightValue;
  return modalHeight({
    heightValue: heightValue
  });
});
StyledModalContainer.displayName = "StyledModalContainer";
//# sourceMappingURL=Modal.js.map